"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState } from "react";
import { Flower } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
const teamMembers = [{
  name: "Ahmed Al-Mansoori",
  position: "Infrastructure Architect",
  bio: "Specializing in high-availability server environments and large-scale virtualization for luxury hospitality brands.",
  favoriteFlower: "VMware vSphere",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/leadership_ahmed_mansoori.png"
}, {
  name: "Sarah Jenkins",
  position: "Cybersecurity Lead",
  bio: "Expert in proactive threat hunting and edge-to-edge encryption protocols for enterprise-level data protection.",
  favoriteFlower: "Zero Trust Architecture",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/leadership_sarah_jenkins.png"
}];
function TeamMemberCard({
  member,
  index
}: {
  member: typeof teamMembers[0];
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div data-index={index} className="flex flex-col items-center text-center group" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <Popover open={isOpen}>
        <PopoverTrigger asChild>
          <div className="cursor-pointer flex flex-col items-center transition-transform duration-500 ease-out group-hover:-translate-y-2">
            <SafeHydrate><Avatar className="size-40 md:size-48 mb-6 border-4 border-border shadow-lg shadow-black/40 transition-all duration-500 group-hover:shadow-primary/20 group-hover:border-primary/40">
              <AvatarImage src={member.image} alt={member.name} className="object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
              <AvatarFallback className="text-4xl font-default bg-muted text-muted-foreground">
                {member.name.split(' ').map(n => n[0]).join('')}
              </AvatarFallback>
            </Avatar></SafeHydrate>
            <h3 className="text-2xl font-bold font-default text-foreground mb-1 tracking-tight">
              {member.name}
            </h3>
            <p className="text-primary font-bold mb-4 font-mono tracking-widest uppercase text-xs">
              {member.position}
            </p>
            <p className="text-muted-foreground text-sm md:text-base max-w-[280px] leading-relaxed font-serif">
              {member.bio}
            </p>
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-auto py-2.5 px-5 text-xs bg-card/90 backdrop-blur-md text-card-foreground border-border shadow-2xl rounded-md pointer-events-none" side="top" align="center" sideOffset={16}>
          <div className="flex items-center gap-2.5 font-medium font-mono">
            <Flower className="size-4 text-secondary animate-pulse" />
            <span>Technical Specialty: <span className="text-secondary">{member.favoriteFlower}</span></span>
          </div>
        </PopoverContent>
      </Popover>
    </div>;
}
export default function MastersBehindDecorations() {
  return <section data-section-id="236228" id="expert-leadership" className="bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="text-4xl md:text-6xl font-bold font-default text-foreground mb-6 tracking-tighter uppercase">
            Expert Leadership
          </h2>
          <p className="text-lg text-muted-foreground font-serif leading-relaxed">
            Our executive team combines decades of technical mastery with a deep understanding of business efficiency. We architect the resilient digital foundations that power the UAE's most prestigious enterprises.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-16 md:gap-24 max-w-4xl mx-auto">
          {teamMembers.map((member, i) => <TeamMemberCard key={i} member={member} index={i} />)}
        </div>
      </div>
    </section>;
}